<template>
  <div>
    <!-- 正文 -->
    <div class="content-main" :class="{'plus-content-main':plusContentManFlag}">
      <!-- 面包屑 -->
      <breadcrumb :menuObject="menuObject" @middleWare="middleWare"  />
      <el-divider></el-divider>
      <!-- 左侧引入导航栏 -->
      <div class="flex">
        <left-menu
          class="left-menu"
          :menuObject="menuObject"
          @middleWare="middleWare"
        />
        <div class="right-content">
          <RightCom
            type="product"
            :queryObject="queryObject"
            :isShowBrandTag="true"
            @setShowAnProduct="setShowAn"
            :key="queryObject.collectionId + queryObject.menuName"
            @showLogin="showLoginHandle"
            @pageChanged="updatePage"
          ></RightCom>
        </div>
      </div>
    </div>
    <footer-com
      :value="showan"
      @hideShow="showan = false"
      :key="showan"
    ></footer-com>
  </div>
</template>

<script>
import Breadcrumb from '../components/breadcrumb.vue'
import HeaderCom from '../components/floatHeader.vue'
import LeftMenu from '../components/left-menu.vue'
import NavCom from '../components/nav.vue'
import RightCom from '../search/index.vue'
import FooterCom from '../home/components/homeFooter.vue'
import { getAction, postAction } from '@/api/manage.js'
import {buryingPoint} from '../../utils/log'
export default {
  name: 'Product',
  components: { HeaderCom, NavCom, LeftMenu, Breadcrumb, RightCom, FooterCom },
  props: ['showLogin'],
  data() {
    return {
      nowPage: 1,
      pageFrom: '',
      lastRouterName: '',
      showan: false,
      items: {},
      showProdcut: true, //
      menuObject: {}, // 左侧集合
      queryObject: {}, // 左侧查询id
      paramsObject: {}, // 参数集合
      gtagSecondId: ['Kids', 'Apparel'],
      categoryMixpanel: '',
      collectionMixpanel: '',
      plusContentManFlag: localStorage.getItem('showOnHold') === 'true'
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.lastRouterName = from.name
      console.log(from.name, 'pagefrom', vm.lastRouterName)
      console.log(from)
    })
  },
  watch: {
    menuObject: {
      handler(n, o) {
        if (JSON.stringify(n) !== '{}') {
          this.loadData(n)
        }
        // document.title = n.secondItem.cateName?n.secondItem.cateName + ' wholesale ＆dropshipping at ShopVidi.com':'wholesale ＆dropshipping at ShopVidi.com'
      },
      deep: true
    },

    $route(n, o) {
      // notes 20220525 只有点击上面的导航才刷新，这样点击面包屑和左侧菜单都不用重新加载了
      // if (localStorage.getItem('from')) {
      //   localStorage.removeItem('from')

      // }
      this.judgeItem()
      // this.menuObject = { ...this.menuObject, ...{} }
    }
  },
  created() {
    // 判断是否有1级，如果1级都没有，那就默认不显示商品
    this.judgeItem()
  },
  computed: {
    isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    }
  },
  methods: {
    updatePage(val) {
      if (this.$route.name == 'category') {
        mixpanel.track('v_category', {
          category: this.$route.params.thirdName || this.$route.params.secondName || this.$route.params.firstName,
          page_number: 1,
          page_form: localStorage.getItem('page_form')
        })
      }
    },
    setShowAn(data) {
      this.showan = data
    },
    showLoginHandle() {
      this.$emit('showLogin')
    },
    middleWare() {},
    /**
     * 判断是否展现菜单和默认选中菜单
     */
    async judgeItem() {
      // this.menuObject = {}
      // 判断选中的是几级菜单，先判断localstorage里面有没有菜单的信息,如果没有则查询
      if (localStorage.getItem('meauData') === undefined || localStorage.getItem('meauData') === null) {
        await this.loadMenuList()
      }
      if (this.$route.params.firstName && this.$route.params.secondName && this.$route.params.thirdName) {
        var seourlname =
          this.$route.params.firstName + '/' + this.$route.params.secondName + '/' + this.$route.params.thirdName
      } else if (this.$route.params.firstName && this.$route.params.secondName) {
        var seourlname = this.$route.params.firstName + '/' + this.$route.params.secondName
      } else if (this.$route.params.firstName) {
        var seourlname = this.$route.params.firstName
      }
      postAction('/ts/seo/router/' + this.$route.name, {
        url: seourlname
      }).then((res) => {
        if (res.success) {
          this.categoryMixpanel = ''
          this.collectionMixpanel = ''
          // 有的话则直接取
          let menuList = JSON.parse(localStorage.getItem('meauData'))
          // 循环看选择了哪一个
          if (menuList.length > 0) {
            let tempMenuObject = {}
            let selectedMenuList = []
            menuList.forEach((element) => {
              // notes haoyuanw  add 增加NewProduct 的跳转 如果是 newproduct 那么则不走else
              if (this.$route.params.secondName && this.$route.params.secondName === 'new-product') {
                if (element.seoUrl === ('/' + this.$route.params.firstName)) {
                  selectedMenuList.push(element)
                  tempMenuObject.menuList = selectedMenuList
                  // notes 因为是new product 所以不用判断三级，三级肯定没选中
                  tempMenuObject.secondItem = element.childrenList[0]
                }
              } else {
                if (element.name === (this.$route.name == 'category' ? res.result.firstCategoryName : res.result.firstCollectionName)) {
                // 将这个一级放入List 然后放入menuObject
                  selectedMenuList.push(element)
                  tempMenuObject.menuList = selectedMenuList
                  // haoyuanw add 2021-10-19 动态显示标题
                  if (tempMenuObject.menuList[0].collectionName) {
                  // 如果有是collection 则给出标题
                  // eslint-disable-next-line no-undef
                    mixpanel.track('v_collection', {
                      collection: tempMenuObject.menuList[0].collectionName
                    })
                    this.collectionMixpanel = this.collectionMixpanel + tempMenuObject.menuList[0].collectionName
                  } else {
                  // eslint-disable-next-line no-undef
                    mixpanel.track('v_category', {
                      category: tempMenuObject.menuList[0].cateName,
                      page_number: 1,
                      page_form: localStorage.getItem('page_form')
                    })
                    this.categoryMixpanel = this.categoryMixpanel + tempMenuObject.menuList[0].cateName
                  }
                  // 已经选中了1级，判断是否传了2级菜单然后再遍历一级选中2级
                  if (res.result.secondCollectionName || res.result.secondCategoryName) {
                    element.childrenList.forEach((secondChildren) => {
                      if (
                        this.gtagSecondId.includes(
                          this.$route.name == 'category'
                            ? res.result.firstCategoryName
                            : res.result.firstCollectionName
                        )
                      ) {
                        gtag('event', 'conversion', {
                          send_to: 'AW-10872645711/R6tzCLj8uK4DEM_QvcAo'
                        })
                      }
                      if (
                        (this.$route.name == 'category'
                          ? secondChildren.cateName
                          : secondChildren.collectionName) ==
                      (this.$route.name == 'category'
                        ? res.result.secondCategoryName
                        : res.result.secondCollectionName)
                      ) {
                        const secondItem = secondChildren
                        tempMenuObject.secondItem = secondItem
                        if (tempMenuObject.secondItem.collectionName) {
                        // 如果有是collection 则给出标题
                        // eslint-disable-next-line no-undef
                          mixpanel.track('v_collection', {
                            collection: tempMenuObject.secondItem.collectionName
                          })
                          this.collectionMixpanel = this.collectionMixpanel + '  /  ' + tempMenuObject.secondItem.collectionName
                        } else {
                        // eslint-disable-next-line no-undef
                          mixpanel.track('v_category', {
                            category: tempMenuObject.secondItem.cateName,
                            page_number: 1,
                            page_form: localStorage.getItem('page_form')
                          })
                          this.categoryMixpanel = this.categoryMixpanel + '  /  ' + tempMenuObject.secondItem.cateName
                        }
                        // 再判断是否选中的三级菜单
                        if (res.result.thirdCollectionName || res.result.thirdCategoryName) {
                          secondItem.childrenList.forEach((thirdChildren) => {
                            if (
                              (this.$route.name == 'category'
                                ? thirdChildren.cateName
                                : thirdChildren.collectionName) ==
                            (this.$route.name == 'category'
                              ? res.result.thirdCategoryName
                              : res.result.thirdCollectionName)
                            ) {
                              tempMenuObject.thirdItem = thirdChildren
                              if (tempMenuObject.thirdItem.collectionName) {
                              // 如果有是collection 则给出标题
                              // eslint-disable-next-line no-undef
                                mixpanel.track('v_collection', {
                                  collection:
                                  tempMenuObject.thirdItem.collectionName
                                })
                                this.collectionMixpanel = this.collectionMixpanel + '  /  ' + tempMenuObject.thirdItem.collectionName
                              } else {
                              // eslint-disable-next-line no-undef
                                mixpanel.track('v_category', {
                                  category: tempMenuObject.thirdItem.cateName,
                                  page_number: 1,
                                  page_form: localStorage.getItem('page_form')
                                })
                                this.categoryMixpanel = this.categoryMixpanel + '  /  ' + tempMenuObject.thirdItem.cateName
                              }
                            }
                          })
                        }
                      }
                    })
                  }
                }
              }
            })
            if (this.categoryMixpanel !== '') {
              mixpanel.track('category', {
                category: this.categoryMixpanel})
            } else {
              mixpanel.track('collection', {
                collection: this.collectionMixpanel})
            }
            this.menuObject = tempMenuObject
            this.loadData(this.menuObject)
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    loadData(data) {
      let id = ''
      let type = ''
      let menuName = ''
      if (data.thirdItem !== undefined) {
        id = data.thirdItem.id
        menuName = data.thirdItem.cateName ? data.thirdItem.cateName : data.thirdItem.collectionName
        type = data.thirdItem.cateName ? 'categoryId' : 'collectionId'
      } else if (data.secondItem !== undefined) {
        id = data.secondItem.id
        menuName = data.secondItem.cateName
          ? data.secondItem.cateName
          : data.secondItem.collectionName
        type = data.secondItem.cateName ? 'categoryId' : 'collectionId'
      } else {
        id = data.menuList[0].id
        menuName = data.menuList[0].cateName ? data.menuList[0].cateName : data.menuList[0].collectionName
        type = data.menuList[0].cateName ? 'categoryId' : 'collectionId'
        if (data.menuList[0]['barType'] === 'collection') {
          type = 'collectionId'
        }
      }

      this.queryObject = {}
      this.queryObject = {
        ...this.queryObject,
        ...{
          [type]: id,
          menuName: menuName
        }
      }

      // 添加以下if是为了解决先点击分类或者collection，再搜索，会多次记录日志 add by cpgu 2022/12/03
      if (this.$route.name !== 'search') {
        buryingPoint(this.$route.name == 'category' ? '4' : '6', id, menuName, this.$route.name)
      }
    },
    async loadMenuList() {
      let resultNavList = []
      // 这里要同步加载，要先加载collection 在加载 category保证显示顺序的正常
      let res = await getAction('/collection-info/all-list')
      if (res.success) {
        const result = this.updateNavList(res.result)
        resultNavList.push(...result)
      } else {
        this.$message.warning(res.message)
      }
      res = await getAction('/tsCategory/tsCateInfo/all-list')
      if (res.success) {
        const result = this.updateNavList(res.result)
        resultNavList.push(...result)
      } else {
        this.$message.warning(res.message)
      }
      localStorage.setItem('meauData', JSON.stringify(resultNavList))
    },
    /**
     * 封装处理一级分类以及
     */
    updateNavList(result) {
      let resultNavList = []
      if (result.length <= 0) {
        this.$message.warning('No Data')
        return ''
      }
      result.forEach((element) => {
        element.name = element.collectionName ? element.collectionName : element.cateName

        // add by cpgu 2022/11/16 添加以下if，对于collection begin
        if (element['barType'] === 'collection' && element.name !== 'Featured') {
          resultNavList.push(element)
        } else {
          // 组装一个 NewProduct 放到2级的集合里
          const newProdcut = {}
          newProdcut.id = 'new' + element.id
          newProdcut.seoUrl = element.seoUrl + '/new-product'
          const type = element.cateName ? 'cateName' : 'collectionName'
          newProdcut.name = 'New Releases'
          newProdcut[type] = 'New Releases'
          newProdcut.childrenList = []
          element.childrenList.splice(0, 0, newProdcut)

          resultNavList.push(element)
        }
        // end by cpgu
      })
      return resultNavList
    }

  }
}
</script>

<style lang="less" scoped>
.container {
  padding-top: 15px;
  position: relative;
  font-family: Graphik;
}
.flex {
  width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.left-menu {
  min-width: 200px;
  margin-top: 10px;
}
.right-content {
  width: 1120px;
}
.content-main {
  width: 1400px;
  margin: 0 auto;
  // margin-top: 158px;添加顶部广告之前的
  margin-top: 200px;
}
.plus-content-main{
  margin-top: 250px;
}
.el-divider--horizontal {
  margin: 15px 0;
}
@media screen and (max-width: 600px) {
  .left-menu {
    display: none;
  }
  .content-main {
    max-width: 100%;
    box-sizing: border-box;
    padding: 0 15px 10px;
    // margin-top: 50px;添加顶部广告之前的
    margin-top: 90px;
  }
  .plus-content-main{
    // margin-top: 160px !important;
    margin-top: 100px !important;
  }
  .right-content {
    max-width: 100%;
  }
  .flex {
    max-width: 100%;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/index.vue